import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../../box';
import { IconButton } from '../../button';
import { IconMoreHoriz } from '../../icon';
import { Tooltip } from '../../tooltip';
export const MoreButton = (props) => {
    return (_jsxs(FlexBox, { position: "relative", sx: props.sx, "data-role": "more-button", children: [_jsx(Tooltip, { title: props.tooltip, children: _jsx(IconButton, { size: "small", sx: {
                        position: 'absolute',
                        left: -5,
                        top: -5
                    }, onClick: (e) => {
                        e.stopPropagation();
                        props.onClick?.();
                    }, icon: "IconMoreHoriz", iconProps: {
                        color: (theme) => props.active
                            ? theme.palette.primary.main
                            : undefined
                    } }) }), _jsx(IconMoreHoriz, { fontSize: "small", visibility: "hidden" })] }));
};
